/*
 * Copyright (c) 2020 Staffino, s.r.o. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Martin Komara, April 2020
 */

const breakpoints: any = ['640px', '832px', '1024px'];
// aliases
breakpoints.small = 0;
breakpoints.medium = breakpoints[0];
breakpoints.large = breakpoints[1];

const createMediaQuery = (breakpoint) => `@media (min-width: ${breakpoint})`;
const tabletMediaQuery =
  '@media (min-width: 768px) and (max-width: 1024px) and (orientation: portrait)';

const mq = breakpoints.map(createMediaQuery);
mq.small = createMediaQuery(breakpoints.small);
mq.medium = createMediaQuery(breakpoints.medium);
mq.large = createMediaQuery(breakpoints.large);
mq.tablet = tabletMediaQuery;

const theme = {
  colors: {
    primary: '#00b92e',
    primaryBackground: '#00b92e',
    primaryText: '#fff',
    secondary: '#ff5a00',
    secondaryBackground: '#ff5a00',
    secondaryText: '#fff',
    action: '#4da1ff',
    actionBackground: '#4da1ff',
    actionText: '#fff',
    highlight: '#E5FAFF',
    warning: '#fff09a',
    notification: '#eb382f',
    background: '#f6f9fb',
    separator: '#d8e1eb',
    lightText: '#a3b2bf',
    text: '#586474',
    headline: '#1f263a',
  },

  breakpoints,
  mq,
};
export default theme;

export type Theme = typeof theme;
